import React from "react";
import {
  Plan2PlateDrawer,
  Plan2PlateDrawerHeader,
  DrawerSelection,
} from "./Plan2PlateDrawer";
import { ImageScannerHiddenInput } from "./ImageScannerHiddenInput";

export type DishAiSourceSelectionDrawerProps = {
  open: boolean;
  onClose: () => void;
  onSelectText: () => void;
  onSelectUrl: () => void;
  onSelectImage: (file: File) => void;
};

export const DishAiSourceSelectionDrawer = ({
  open,
  onClose,
  onSelectText,
  onSelectUrl,
  onSelectImage,
}: DishAiSourceSelectionDrawerProps) => {
  const { trigger: triggerCamera, input: cameraInput } =
    ImageScannerHiddenInput({
      onFileScanned: (file) => {
        // Quellen-Drawer bleibt offen; der Import-Drawer wird darüber gestapelt
        // und schließt beim Fertigstellen beide (wie bei Text/URL).
        onSelectImage(file);
      },
    });

  return (
    <>
      {cameraInput}
      <Plan2PlateDrawer
        open={open}
        onClose={onClose}
        header={<Plan2PlateDrawerHeader heading="KI-Import Quelle" />}
        body={
          <>
            <DrawerSelection
              onClick={() => {
                onSelectText();
              }}
              icon="pencil"
              heading="Text einfügen"
              description="Füge ein kopiertes Rezept aus der Zwischenablage ein"
            />
            <DrawerSelection
              onClick={triggerCamera}
              icon="clipboardImage"
              heading="Foto machen / auswählen"
              description="Mache ein Foto von einem Rezept aus einem Kochbuch oder Magazin"
            />
            <DrawerSelection
              onClick={() => {
                onSelectUrl();
              }}
              icon="chain"
              heading="URL eingeben"
              description="Füge einen Link zu einem Rezept aus dem Internet ein"
            />
          </>
        }
      />
    </>
  );
};
